import _          from 'lodash'
import Immutable  from 'immutable'
import CourseMenu from './course_menu'

export class InvalidMealSelection
  constructor: (@courseMenu) ->
    @name    = @constructor.name
    @stack   = (new Error).stack
    @message = ("Invalid selection #{@courseMenu.selectedMealNumber} " +
                "from #{@courseMenu.meals.map((meal) -> meal.number).toArray()}")

  @::__proto__ = Error::

export default class CourseMenuWithOrder extends CourseMenu
  constructor: (canteen, date, course, meals, selectedMealNumber, savedMealNumber) ->
    super(canteen, date, course, meals)

    if selectedMealNumber and not meals.some (meal) => meal.number == selectedMealNumber
      throw new InvalidMealSelection(@)

    @selectedMealNumber = selectedMealNumber
    @savedMealNumber    = savedMealNumber

  selectedMeal: ->
    @selectedMealNumber and @meals.find (meal) => meal.number == @selectedMealNumber

  select: (selectedMealNumber) ->
    new @constructor(@canteen, @date, @course, @meals, selectedMealNumber, @savedMealNumber)

  deselect: ->
    new @constructor(@canteen, @date, @course, @meals, null, @savedMealNumber)

  safeSelect: (selectedMealNumber) ->
    try @select(selectedMealNumber)
    catch InvalidMealSelection then @

  save: ->
    new @constructor(@canteen, @date, @course, @meals, @selectedMealNumber, @selectedMealNumber)

  cancel: ->
    new @constructor(@canteen, @date, @course, @meals, null, null)

  isSaved: ->
    @savedMealNumber == @selectedMealNumber

  hasSelection: ->
    !!@selectedMealNumber
